import React, {useLayoutEffect, useState} from 'react';
import {useModal} from '../../../shared/components/modal';
import {useNavigation} from '@react-navigation/native';
import {EsiaRegCardFlowHandler} from './components/form/desktop';
import {Screens} from '../../../shared/routing';
import {loginSlice} from '../../../redux/reducers/login';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {LoginState} from '../../../shared/models/login/loginStep';
import {useDispatch, useSelector} from 'react-redux';
import {esiaUserHasNoCardsSelector} from '../../../redux/selectors/login';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import View from './view';

export const EsiaRegCard = () => {
  const isDesktopSize = useIsDesktop();
  const [isEsiaProcessingAccepted, setIsEsiaProcessingAccepted] = useState(false);
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const modals = useModal();
  const showModal = React.useCallback(() => {
    if (isDesktopSize) {
      modals.show({
        render(modal, methods) {
          const onClose = () => {
            dispatch(loginSlice.actions.reset(null));
            dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
            methods.remove(modal.id);
          };
          return <EsiaRegCardFlowHandler onClose={onClose} />;
        },
      });
    } else {
      navigation.navigate(userHasNoCards ? Screens.EsiaActivateCard : Screens.EsiaRegistrationCardUserSelecting);
    }
  }, [modals, userHasNoCards]);
  const onButtonPress = () => {
    showModal();
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.esiaRegCardUsersHandling));
  };

  useLayoutEffect(() => {
    if (userHasNoCards) showModal();
  }, []);

  return (
    <View
      isEsiaProcessingAccepted={isEsiaProcessingAccepted}
      setIsEsiaProcessingAccepted={setIsEsiaProcessingAccepted}
      onButtonPress={onButtonPress}
    />
  );
};
